<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts/dist/echarts.js';
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import $ from 'jquery'
// require('echarts/theme/macarons') // echarts theme

const animationDuration = 6000

export default {
  props: {
    authorData: {
      type: Array,
      default: function() { return [] }
    },    
    yAxisData: {
      type: Array,
      default: function() { return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] }
    },
    xAxisData: {
      type: Array,
      default: function () { return [30, 52, 200, 334, 390, 330, 220] }
    },
    axisNames: {
      type: Array,
      default: function () { return ['High5', 'On the Spot', 'Teams'] }
    },
    listLimit: {
      type: Number,
      default: 10
    },
    className: {
      type: String,
      default: 'chart'
    },
    barDate: {
      type: String,
      default: '3m'
    },
    noClick: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      chart: null,
      chartThemes : ['forest', 'caravan', 'azul', 'bee-inspired', 'fruit', 'fresh', 'sakura', 'london']
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    xAxisData () {
      this.$nextTick(() => {
        this.initChart()
      })
    }
  },
  methods: {
    initChart() {
      let theme = this.chartThemes[Math.floor(Math.random() * this.chartThemes.length)]
      this.chart = echarts.init(this.$el, this.chartThemes[theme])
      let series = []
      var self = this
      $.each (this.axisNames, function (index, val) {
        series.push({
          name: val,
          type: 'bar',
          stack: 'nominations',
          label: {
            show: true,
            position: 'insideLeft'
          },
          barWidth: '60%',
          data: self.xAxisData[index],
          animationDuration
        })
      })
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { 
            type: 'shadow'
          }
        },
        grid: {
          top: this.listLimit,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: [{
          type: 'category',
          data: this.yAxisData,
          axisTick: {
            alignWithLabel: true
          }
        }],
        xAxis: [{
          type: 'value',
          axisTick: {
            show: false
          }
        }],
        series: series
      })
      this.chart.resize()
      var self= this
      if (this.noClick)
      this.chart.on('click', function(params){
        let selDate = 'All';
        let d = new Date()
        if (self.barDate !== 'All') {
          d.setMonth(d.getMonth() - Number(self.barDate.slice(0, 1)) )
          selDate = d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + d.getDate()).slice(-2) + 'T00:00:00'
        }
        console.log('BARCHART click params-> ', params)
        console.log('BARCHART click date-> ', selDate)
        localStorage.setItem('paramAuthor', self.authorData[params.name])
        localStorage.setItem('paramAuthorName', params.name)
        localStorage.setItem('paramDate', selDate)
        localStorage.setItem('paramName', params.seriesName)
        localStorage.setItem('paramCount', params.value)
        location.href= WordpressRestURI.frontEndDomain + 'report-dashboard/' + params.seriesName.toLowerCase() + '/' + self.authorData[params.name]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BarChart.vue